import React, { Component, ReactNode } from 'react';

import { initialise, logError } from './IwDataDogLogger';
import { ManuallyLocalisedFallbackError } from './ManuallyLocalisedFallbackError';
import { isDevelopmentEnv } from '../devOpsHelper/DevOps';

export class IwLogger extends Component<
    { children: ReactNode },
    { hasError: boolean; error: Error | null }
> {
    state = { hasError: false, error: null };

    componentDidMount() {
        if (!isDevelopmentEnv()) {
            initialise();
        }
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        this.setState({ hasError: true, error });

        if (isDevelopmentEnv()) {
            console.error('Reported Error', error);
        } else {
            logError(
                error.message,
                {
                    tags: {
                        reporter: 'catch_component'
                    },
                    info
                },
                error
            );
        }
    }

    render() {
        if (this.state.hasError) {
            return <ManuallyLocalisedFallbackError error={this.state.error} />;
        }

        return this.props.children;
    }
}
